import moment from 'moment';
import React from 'react';
import { IUser } from 'types/users';
import styles from './styles.module.scss';
import { IOutsourcing } from 'types/outsourcing';
import { formatServiceTypeTitle, formatUserFullName } from 'utils/helpers';

const date = new Date();

const OutsTable = ({ data }: { data?: IOutsourcing }) => {
	return (
		<table className={styles.table}>
			<thead>
				<tr>
					<th scope="col">Информация о пользователе</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						ФИО: {formatUserFullName(data?.user)}
					</td>
				</tr>
				<tr>
					<td>Тип услуги: {formatServiceTypeTitle(data?.pos ? data?.pos?.title : data?.position)}</td>
				</tr>
				<tr>
					<td>Компания: {data?.counterparty?.title}</td>
				</tr>
				<tr>
					<td>{moment(date).format('DD.MM.YY HH:mm')}</td>
				</tr>
			</tbody>
		</table>
	);
};

export default OutsTable;
